import agent from "../../../api/agent";

export const getTableCsv = (url)                => agent.requests.post(url);
